import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const validateSchema = async (fields) => {
  let schemaFields = {};
  let fieldsValidation = {};

  fields.forEach((field) => {
    // Skip disabled fields — they're not rendered, user can't edit them
    if (field.enabled === false) {
      return;
    }

    // Check if this field has required() or conditional (.when()) validation
    const tests = field.validation && field.validation.describe().tests;
    const isRequired = tests && tests.some(t => t.name === 'required');
    const isConditional = field.validation && field.validation._conditions &&
      field.validation._conditions.length > 0;

    // Skip optional, non-conditional empty fields — yup v0 rejects '' for ALL types
    // Required or conditional (when) empty fields MUST be validated by yup
    if (!isRequired && !isConditional &&
        (field.value === '' || field.value === null || field.value === undefined)) {
      return;
    }
    schemaFields[field.name] = field.validation;

    // For required fields: convert '' to null so yup can handle it
    // yup v0 rejects '' for all types, but accepts/rejects null per schema
    fieldsValidation[field.name] = field.value === '' ? null : field.value;
  });

  const schema = yup.object().shape(schemaFields);

  try {
    const validated = await schema.validate(fieldsValidation);

    // Apply API transformations
    fields.forEach((field) => {
      if (!(field.name in validated)) {
        // Field was skipped in validation
        const isSelect = field.type === FormFieldType.SELECT;
        const isNumber = field.validation && field.validation.describe().type === 'number';
        
        if (field.value === '' && (isSelect || isNumber)) {
          validated[field.name] = null;
        } else {
          validated[field.name] = field.value;
        }
      } else if (field.type === FormFieldType.CHECKBOX) {
        validated[field.name] = Boolean(field.value);
      } else if (
        typeof field.value === 'string' && field.value !== '' &&
        typeof validated[field.name] === 'string' &&
        ![
          FormFieldType.SELECT_CHIP,
          FormFieldType.SELECT,
          FormFieldType.CHECKBOX
        ].includes(field.type)
      ) {
        // Non-empty, non-select string fields → uppercase+trim for API
        validated[field.name] = field.value.toUpperCase().trim();
      }
      // Everything else keeps yup's coerced value (Date, number, null, etc.)
    });

    return validated;
  } catch (error) {
    return error;
  }
};

export default validateSchema;
